import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StandardListLayout } from '@/shared/layout/StandardListLayout';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { useAgroProductList } from './hooks/useAgroProductList';
import { AgroProductKpiGrid } from './components/AgroProductKpiGrid';
import { AgroProductTable } from './components/AgroProductTable';
import { AgroProductMobileCards } from './components/AgroProductMobileCards';
import { AgroProductToolbar } from './components/AgroProductToolbar';
import type { AgroProductListItem } from './types/agroProductList.types';

export function AgroProductListPage() {
  const navigate = useNavigate();
  const {
    data, isLoading, isDeleting, filters, filterOptions, page, pageSize,
    canEdit, canDelete,
    handleSearch, handleStatusChange, handleFilterChange, deleteItem, updatePage, updatePageSize,
  } = useAgroProductList();

  const [deleteTarget, setDeleteTarget] = useState<AgroProductListItem | null>(null);

  const handleDelete = async () => {
    if (!deleteTarget) return;
    await deleteItem(deleteTarget.id);
    setDeleteTarget(null);
  };

  return (
    <StandardListLayout
      title="Phân - Thuốc"
      description="Quản lý danh mục phân bón và thuốc bảo vệ thực vật"
      isLoading={isLoading}
      viewMode="table"
      kpiSection={<AgroProductKpiGrid stats={data.stats} isLoading={isLoading} />}
      toolbarSection={
        <AgroProductToolbar
          filters={filters}
          filterOptions={filterOptions}
          onSearchChange={handleSearch}
          onStatusChange={handleStatusChange}
          onFilterChange={handleFilterChange}
        />
      }
      tableSection={
        <AgroProductTable
          items={data.items}
          total={data.total}
          page={page}
          pageSize={pageSize}
          isLoading={isLoading}
          onView={(id) => navigate(`/agro/detail/${id}`)}
          onEdit={(id) => navigate(`/agro/edit/${id}`)}
          onDelete={setDeleteTarget}
          canEdit={canEdit}
          canDelete={canDelete}
          onPageChange={updatePage}
          onPageSizeChange={updatePageSize}
        />
      }
      cardSection={
        <AgroProductMobileCards
          items={data.items}
          total={data.total}
          page={page}
          pageSize={pageSize}
          isLoading={isLoading}
          onView={(id) => navigate(`/agro/detail/${id}`)}
          onEdit={(id) => navigate(`/agro/edit/${id}`)}
          onDelete={setDeleteTarget}
          canEdit={canEdit}
          canDelete={canDelete}
          onPageChange={updatePage}
          onPageSizeChange={updatePageSize}
        />
      }
    >
      <ConfirmDialog
        isOpen={!!deleteTarget}
        title="Xóa vật tư"
        message={
          <span>
            Bạn có chắc chắn muốn xóa vật tư <strong>{deleteTarget?.name}</strong>? Hành động này không thể hoàn tác.
          </span>
        }
        confirmText="Xóa"
        cancelText="Hủy"
        isDestructive
        isLoading={isDeleting}
        onConfirm={handleDelete}
        onClose={() => setDeleteTarget(null)}
      />
    </StandardListLayout>
  );
}

export default AgroProductListPage;
